<template lang="pug">
  v-dialog(:value="actived"
    transition="dialog-bottom-transition"
    fullscreen
    persistent)
    v-card
      v-toolbar(color="primary" dark)
        v-btn(icon dark @click="($emit('update:actived', false), $emit('close'))")
          v-icon close
        v-toolbar-title {{ title }}
        v-spacer
        v-btn(:loading="loading" dark outline @click="$emit('submit', data)") {{ submitText }}
      slot
</template>
<script>
export default {
  name: "BaseFullFormDialog",
  props: {
    actived: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    submitText: {
      type: String,
      default: "送出"
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: null
    };
  }
};
</script>
